export default "__VITE_ASSET__0Isb0pmY__"